import { StyledAuth, StyledSelect } from "./style";
import { MyButton, MyText } from "../../components";
import { Col, Flex, Form, Input, Row, Select, Empty } from "antd";
import { LogoIcon } from "../../assets";
import { useState, useEffect, useCallback } from "react";
import { RegistrationSteps } from "../../components/common/MySteps";
import { LANG_KEY } from "../../utils/constants/language";
import { MySegmented } from "../../components";
import { Link, useNavigate } from "react-router-dom";
import { ROUTE_PATH,fetchCitiesListAction,fetchDistrictsListAction,fetchModules, fetchRegionsListAction, fetchUpdateProfileAction } from "../../utils/"
import { useLang } from "../../utils/context/lang";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useEmbeddedLink } from "../../utils/context/embed";
import { useEmbeddedNavigate } from "../../utils/context/embed";
const FORM_NAME = {
  name: 'name',
  birthDate: 'birthDate',
  region: 'region',
};

export const RegisterConfirm = () => {
  const {t} = useTranslation("common")
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(2);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [name, setName] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [isExiting, setIsExiting] = useState(false);
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  
  const {handleChangeLang, lang} = useLang()
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [regions, setRegions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const { Option } = Select;
  const dispatch = useDispatch();
  const embeddedLink = useEmbeddedLink();
  const updateProfile = useSelector((state: any) => state.materials?.updateProfile ?? { loading: false });
  const regionsList = useSelector((state: any) => state.materials?.regionsList ?? { data: null, loading: false });
  const districtsList = useSelector((state: any) => state.materials?.districtsList ?? { data: null, loading: false });
  const citiesList = useSelector((state: any) => state.materials?.citiesList ?? { data: null, loading: false });

  const [formData, setFormData] = useState({
      firstName: '',
      lastName: '',
      region: null,
      district: null,
      settlement: null,
    });


  // useEffect(() => {
  //   const isEnabled = name.trim() !== '' && birthDate.trim() !== '' && selectedRegion !== null;
  //   setIsButtonDisabled(!isEnabled);
  // }, [name, birthDate, selectedRegion]);

  // const handleFieldChange = (changedValues) => {
  //   if (changedValues.name) {
  //     setName(changedValues.name);
  //   }
  //   if (changedValues.birthDate) {
  //     setBirthDate(changedValues.birthDate);
  //   }
  // };

  // useEffect(() => {
  //   if (selectedRegion) {
  //       const fetchDistricts = async () => {
  //           try {
  //               const response = await fetchRegions(selectedRegion)
  //               setDistricts(response?.items); 
  //           } catch (error) {
  //               console.error('Ошибка при получении городов', error);
  //           }
  //       };
  //       fetchDistricts();
  //   }
  // }, [selectedRegion]);
  
  
  // useEffect(() => {
  //   if (selectedDistrict) {
  //       const fetchCities = async () => {
  //           try {
  //               const response = await fetchRegions(selectedDistrict)
  //               setCities(response?.items); 
  //           } catch (error) {
  //               console.error('Ошибка при получении городов', error);
  //           }
  //       };
  //       fetchCities();
  //   }
  // }, [selectedDistrict]);

  //   useEffect(() => {
  //     const fetchRegionsData = async () => {
  //         try {
  //             const response = await fetchRegions();
  //             setRegions(response?.items);
  //         } catch (error) {
  //             console.error('Ошибка при получении регионов', error);
  //         }
  //     };
  //     fetchRegionsData();
  // }, []);

  useEffect(() => {
    dispatch(fetchRegionsListAction());
  }, []);

  useEffect(() => {
    if (!regionsList.success || !regionsList.data) return;
    setRegions(regionsList.data?.items || []);
  }, [regionsList.success, regionsList.data]);

  useEffect(() => {
    if (!selectedRegion) return;
    dispatch(fetchDistrictsListAction(selectedRegion));
  }, [selectedRegion]);

  useEffect(() => {
    if (!districtsList.success || !districtsList.data) return;
    setDistricts(districtsList.data?.items || []);
  }, [districtsList.success, districtsList.data]);

  useEffect(() => {
    if (!selectedDistrict) return;
    dispatch(fetchCitiesListAction(selectedDistrict));
  }, [selectedDistrict]);

  useEffect(() => {
    if (!citiesList.success || !citiesList.data) return;
    setCities(citiesList.data?.items || []);
  }, [citiesList.success, citiesList.data]);

const handleRegionChange = (value: any) => {
  setSelectedRegion(value);
  setSelectedDistrict(null);
  setSelectedCity(null);

  form.setFieldsValue({
    district: null,
    settlement: null,
    region: value,
  });

  setFormData((prev) => ({ 
    ...prev, 
    region: value, 
    district: null, 
    settlement: null  
  }));
};

const handleDistrictChange = (value: any) => {
  setSelectedDistrict(value);
  setSelectedCity(null);

  form.setFieldsValue({
    district: value,
    settlement: null,
  });

  setFormData((prev) => ({ 
    ...prev, 
    district: value, 
    settlement: null 
  }));
};

const handleCityChange = (value: any) => {
  setSelectedCity(value);
  form.setFieldsValue({ settlement: value });

  setFormData((prev) => ({ 
    ...prev, 
    settlement: value 
  }));
};

const handleInputChange = (field: string, value: string | boolean) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

//   useEffect(() => {
//   const { firstName, lastName, region, district, settlement } = formData;
//   console.log(formData)
//   const isFormComplete =
//     firstName && lastName &&
//     region !== null &&
//     district !== null &&
//     settlement !== null;

//   setIsButtonDisabled(!isFormComplete);
// }, [formData]);

useEffect(() => {
  const { firstName, lastName, region, district, settlement } = formData;

  const selectedRegion = regions.find(r => r.id === region);
  const selectedDistrict = districts.find(d => d.id === district);
  const selectedSettlement = cities.find(s => s.id === settlement);

  const hasLocalitySelected =
    (selectedRegion?.type === 'locality') ||
    (selectedDistrict?.type === 'locality') ||
    (selectedSettlement?.type === 'locality');

  const isFormComplete =
    firstName &&
    lastName &&
    (
      (region && district && settlement) ||
      hasLocalitySelected
    );

  setIsButtonDisabled(!isFormComplete);
}, [formData, regions, districts, cities]);


  const handleChangeLangSelect = useCallback((value: any) => {
    handleChangeLang(value)
  }, [])
  
  // const handleSubmit = async () => {
  //   setIsExiting(true);
    
  //   const locality =
  //     cities.find((item) => item.id === formData.settlement && item.type === 'locality') ||
  //     districts.find((item) => item.id === formData.district && item.type === 'locality') ||
  //     regions.find((item) => item.id === formData.region && item.type === 'locality');
  
  //   const profileData = {
  //     first_name: formData.firstName,
  //     last_name: formData.lastName,
  //     region_id: locality?.id || null,
  //   };

  //   try {
  //     await updateUserProfile(profileData);
  //     await dispatch(fetchModules({}));
      
  //     setTimeout(() => {
  //       embeddedNavigate('/');
  //     }, 400);
  //   } catch (error) {
  //     console.error('Failed to update profile:', error);
    
  //   }
  // };

  const handleSubmit = () => {
    setIsExiting(true);
    const getLocality = () =>
    cities.find((item) => item.id === formData.settlement && item.type === 'locality') ||
    districts.find((item) => item.id === formData.district && item.type === 'locality') ||
    regions.find((item) => item.id === formData.region && item.type === 'locality');
    const locality = getLocality();
    dispatch(fetchUpdateProfileAction({
      profileData: {
        first_name: formData.firstName,
        last_name: formData.lastName,
        region_id: locality?.id || null,
      },
      withRefetch: false,
    }));
  };

  useEffect(() => {
    if (!updateProfile.success || !isExiting) return;
    setTimeout(() => {
      embeddedNavigate('/');
    }, 400);
  }, [updateProfile.success]);

  return (
    <StyledAuth className={isExiting ? "fade-out" : "fade-in"}>
      <div style={{ position: 'absolute', top: 40, right: 40 }}>
      <MySegmented
          onChange={(value) => handleChangeLangSelect(value)}
          value={lang}
          options={[
          { label: 'ҚАЗ', value: LANG_KEY.KZ },
          { label: 'РУС', value: LANG_KEY.RU },
            ]}
          />
      </div>

      <Flex justify="center" align='center' style={{ width: 500 }}>
        <Row justify='center' gutter={[16, 16]}>
          <Col>
          <Link to={embeddedLink(ROUTE_PATH.MAIN)}>
            <LogoIcon />
            </Link>
          </Col>

          <Col span={24} style={{ width: 248 }}>
            <RegistrationSteps currentStep={currentStep} />
          </Col>

          <Col span={24}>
            <Form 
            form={form}
            // onValuesChange={handleFieldChange}
            >
              <Row>
                <Col span={24}>
                  <Form.Item name="lastName" labelCol={{ span: 24 }}>
                    <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                    {t("lastName")}
                    </MyText>
                    <Input
                      placeholder={t("enterYourSurname")}
                      style={{ marginTop: 8 }}
                      onChange={(e) => handleInputChange('lastName', e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="firstName" labelCol={{ span: 24 }}>
                    <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                    {t("firstName")}
                    </MyText>
                    <Input
                      placeholder={t("enterYourName")}
                      style={{ marginTop: 8 }}
                      onChange={(e) => handleInputChange('firstName', e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                  {t("regionArea")}
                  </MyText>
                  <Form.Item
                                name="region"
                                rules={[{ required: true, message: t('selectFromList') }]}
                              >
                                <StyledSelect
                                  placeholder={t("selectFromList")}
                                  style={{ width: '100%',marginTop: 6, height: 52 }}
                                  value={selectedRegion}
                                  onChange={handleRegionChange}
                                >
                                  {regions.map((region) => (
                                    <Option key={region.id} value={region.id}>
                                      {region.name}
                                    </Option>
                                  ))}
                                </StyledSelect>
                              </Form.Item>
                </Col>
                 <Col span={24}>
                  <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                  {t("regionDistrict")}
                  </MyText>
                  <Form.Item
                    name="district"
                    rules={[{ required: true, message: t('selectFromList') }]}
                  >
                    <StyledSelect
                      placeholder={t("selectFromList")}
                      style={{ width: '100%', marginTop: 6, height: 52 }}
                      value={selectedDistrict}
                      notFoundContent={<Empty imageStyle={{ height: 80 }} description={t("noData")} />}
                      onChange={handleDistrictChange}
                    >
                      {districts.map((city) => (
                        <Option 
                          key={city.id} 
                          value={city.id} 
                          style={{ fontWeight: city.is_big === 1 ? 'bold' : 'normal' }}
                        >
                          {city.name}
                        </Option>
                      ))}
                    </StyledSelect>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                  {t("settlement")}
                  </MyText>
                   <Form.Item
                                name="settlement"
                                rules={[{ required: true, message: t('selectFromList') }]}
                              >
                                <StyledSelect
                                  placeholder={t("selectFromList")}
                                  style={{ width: '100%', marginTop: 6, height: 52 }}
                                  value={selectedCity}
                                  notFoundContent={<Empty imageStyle={{ height: 80 }} description={t("noData")} />}
                                  onChange={handleCityChange}
                                >
                                  {cities.map((city) => (
                                    <Option 
                                      key={city.id} 
                                      value={city.id} 
                                      style={{ fontWeight: city.is_big === 1 ? 'bold' : 'normal' }}
                                    >
                                      {city.name}
                                    </Option>
                                  ))}
                                </StyledSelect>
                              </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item>
                    <MyButton 
                      type='primary' 
                      htmlType="submit" 
                      color='orange' 
                      style={{ width: '100%', fontSize: '18px' }} 
                      disabled={isButtonDisabled}
                      onClick={handleSubmit}
                    >
                     {t("register")}
                    </MyButton>
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Flex justify="center">
                    <Form.Item>
                      <MyText color='#0A033C' size={20} lineHeight={'32px'}>
                      {t("haveAccount")}
                      </MyText>
                      <Link to={embeddedLink("/auth")}>
                        <MyText color="rgba(0, 141, 210, 1)" style={{ marginLeft: 5 }} size={20} lineHeight={'32px'}>
                        {t("login")}
                        </MyText>
                      </Link>
                    </Form.Item>
                  </Flex>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Flex>
    </StyledAuth>
  );
};
